// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { _DYN_MEASUREMENTS, _DYN_NAME, _DYN_PROPERTIES } from "../../__DynamicConstants";
import { strNotSpecified } from "../../constants/Constants";
import { dataSanitizeMeasurements, dataSanitizeProperties, dataSanitizeString } from "./Common/DataSanitizer";
import { EventDataType } from "./DataTypes";
import { EventEnvelopeType } from "./EnvelopeTypes";
var Event = /** @class */ (function () {
    /**
     * Constructs a new instance of the EventTelemetry object
     */
    function Event(logger, name, properties, measurements) {
        this.aiDataContract = {
            ver: 1 /* FieldType.Required */,
            name: 1 /* FieldType.Required */,
            properties: 0 /* FieldType.Default */,
            measurements: 0 /* FieldType.Default */
        };
        var _self = this;
        _self.ver = 2;
        _self[_DYN_NAME /* @min:%2ename */] = dataSanitizeString(logger, name) || strNotSpecified;
        _self[_DYN_PROPERTIES /* @min:%2eproperties */] = dataSanitizeProperties(logger, properties);
        _self[_DYN_MEASUREMENTS /* @min:%2emeasurements */] = dataSanitizeMeasurements(logger, measurements);
    }
    /**
     * @deprecated Use the constant EventEnvelopeType instead.
     */
    Event.envelopeType = EventEnvelopeType;
    /**
     * @deprecated Use the constant EventDataType instead.
     */
    Event.dataType = EventDataType;
    return Event;
}());
export { Event };
//# sourceMappingURL=Event.js.map